import React from 'react';
import { Wrapper } from './NotFoundPage.styles';
import Container from '../../components/Container/Container';
import { SectionWrapper } from '../../components/Section/Section.styled';
import { Title } from '../../components/CatalogSection/Catalog.styled';
import { Text } from '../../components/AboutClinic/DetailsSection/DetailsSection.styled';
import { LinkStyled } from '../ServicesPage/ServiceDescription/ServiceDescription.styled';
import { ButtonStyled } from '../../components/ButtonLink/ButtonLink.styled';

const NotFoundPage = () => {
    return (
        <SectionWrapper>
            <Container>
                <Wrapper>
                    <Title>Nie znaleźliśmy tej strony!</Title>
                    <Text>Przykro nam, ale ta strona nie jest dostępna. <br /> Proszę spróbować ponownie.</Text>
                    <LinkStyled><ButtonStyled to='/'>Przejdź z powrotem na stronę główną.</ButtonStyled></LinkStyled>
                </Wrapper>
            </Container>
        </SectionWrapper>
    )
};

export default NotFoundPage;